// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bag {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 999;\n  transform: translate(-50%, -50%);\n  width: 139px;\n}\n.start {\n  position: relative;\n  top: -30px;\n  left: 68px;\n}\n.start > img {\n    position: absolute;\n}\n", ""]);
// Exports
module.exports = exports;
